import { LoggedInHTTPError } from "@impero-com/common/errorPages/loggedInHTTPError";
import { useTranslation } from "@impero-com/common/utils/i18n";
import { PageSpinner } from "@impero-com/ui";
import { useParams } from "react-router-dom";

import { OrgApplicationBar } from "components/applicationBar/orgApplicationBar";
import { useControlSuspenseQuery } from "org/control/view/queries/useControlSuspenseQuery";
import { controlIdParamSchema } from "org/controlActivities/urlUtils";
import { WebRoute } from "routes";

import { ControlActivitiesScope } from "./consts";
import { ControlActivitiesList } from "./ControlActivitiesList";
import { useControlActivitiesListData } from "./useControlActivitiesListData";
import { useCopyLinkAction } from "./useCopyLinkAction";

/** One control's activities, with its own persisted view. */
export function ControlActivitiesListForControlPage() {
    const { id: unparsedControlId } = useParams();
    const controlIdParseResult =
        controlIdParamSchema.safeParse(unparsedControlId);

    if (controlIdParseResult.success === false) {
        console.error("Control id parse failed:", unparsedControlId);
        return <LoggedInHTTPError code={400} />;
    }
    return (
        <ControlActivitiesListForControlView
            controlId={controlIdParseResult.data}
        />
    );
}

interface ControlActivitiesListForControlViewProps {
    controlId: string;
}
function ControlActivitiesListForControlView({
    controlId,
}: ControlActivitiesListForControlViewProps) {
    const { t } = useTranslation();
    const { data: controlDto } = useControlSuspenseQuery(controlId);
    const { title } = controlDto.content.resource;
    const actions = useCopyLinkAction();

    return (
        <OrgApplicationBar
            title={{
                breadCrumbs: [
                    {
                        label: t("ControlActivities_Breadcrumb_Controls"),
                        url: WebRoute.CONTROLS_ALL,
                    },
                    { label: title, url: `${WebRoute.CONTROLS}/${controlId}` },
                ],
                title: t("ControlResults_Title"),
            }}
            actions={actions}
        >
            <ControlActivitiesListForControl controlId={controlId} />
        </OrgApplicationBar>
    );
}
function ControlActivitiesListForControl({
    controlId,
}: ControlActivitiesListForControlViewProps) {
    const scope: ControlActivitiesScope = { type: "control", controlId };
    const {
        dataParams,
        dateFilters,
        archivedFilter,
        dto,
        tagCategories,
        isPending,
        isTableLoading,
    } = useControlActivitiesListData(scope);

    if (isPending || !dto) {
        return <PageSpinner />;
    }

    return (
        <ControlActivitiesList
            controlResultsDto={dto}
            tagCategories={tagCategories}
            dataParams={dataParams}
            dateFilters={dateFilters}
            archivedFilter={archivedFilter}
            isTableLoading={isTableLoading}
            scope={scope}
        />
    );
}
